import React, { Component } from "react";
import { Link } from "react-router-dom";
import CongratsCarImg from "../components/congratsCarImg";
import InputForm from "../components/html/inputForm";
import HdfcHeader from "../components/pageBlocks/hdfcHeader";
import commonContext, { AppContext } from "../context/common";
import { leadType } from "../../app";
import OtpPopUp from "../components/otpPopUp";
import { ALDDApis } from "../../ddAl/apis/aLDDApis";
import { Utilities } from "../utils/utilities";
import { CommonApis } from "../apis/commonApis";
import { Authorization } from "../utils/authorization";

interface IProps {
    history?: any;
}
interface IState {
    privacyPolicyCheck: boolean;
    privecyPolicyCheckClass: string;
    mobileInputError: boolean;
    documentSubmit: boolean;
    otpPopUpSwitch: boolean;
    offersValue?: Array<{
        campaignId?: string;
        customerId?: string;
        loanAmt?: string;
        losAppId?: string;
        product?: string;
        promoCode?: string;
        subProduct?: string;
        typeOfCustomer?: string;
    }>;
    otpTimer?: string;
    offerSelectLosAppId?: string;
    offerSelectedProduct?: string;
    offerSelectedSubProduct?: string;
}
export class CustomerVerification extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    setLead: Function;
    apis: ALDDApis;
    cAPI: CommonApis;
    utils: Utilities;
    authKeeper: Authorization;
    formRef: any;

    constructor(props: IProps) {
        super(props);
        this.state = {
            mobileInputError: false,
            privacyPolicyCheck: false,
            privecyPolicyCheckClass: "hidden",
            documentSubmit: false,
            otpPopUpSwitch: false,
        };
        this.formRef = React.createRef();
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        this.setLead = (this.context as AppContext).setLead;
        this.apis = (this.context as AppContext).apis as ALDDApis;
        this.cAPI = (this.context as AppContext).commonAPI as CommonApis;
        this.authKeeper = (this.context as AppContext)
            .authKeeper as Authorization;
    }
    handleOnSubmitMobileVerify = async (e) => {
        e.preventDefault();
        this.lead = (this.context as AppContext).lead as leadType;
        this.utils = (this.context as AppContext).utils as Utilities;

        this.setState({ privecyPolicyCheckClass: "hidden" });
        this.setState({ mobileInputError: false });
        if (!this.lead.mobile) {
            this.setState({ mobileInputError: true });
            return;
        } else if (!this.state.privacyPolicyCheck) {
            this.setState({ privecyPolicyCheckClass: "" });
            return;
        }
        const apiData = await this.cAPI.verifyMobile(this.lead);
        if (apiData.error?.error) {
            return this.props.history.push("error");
        }
        if (!apiData.result?.offerAvailable) {
            return this.props.history.push("error");
        }
        // this.utils.countDown(this);
        this.authKeeper.setAuthorization(apiData.result?.token);
        this.setState({ otpPopUpSwitch: true });
    };
    handleOnReset = () => {
        this.setState({
            mobileInputError: false,
            privacyPolicyCheck: false,
            privecyPolicyCheckClass: "hidden",
        });
    };
    handleOnOTPSubmit = async () => {
        this.lead = (this.context as AppContext).lead as leadType;
        const apiData = await this.cAPI.verifyOTP(this.lead);

        if (apiData.error?.error) {
            if (this.lead.otpAttemptsLeft !== 1) {
                this.setLead({
                    otpAttemptsLeft: --this.lead.otpAttemptsLeft,
                    otpAttemptsLeftText: true,
                });
                // this.countDown(true);
                return;
            } else {
                this.props.history.push("error");
                return;
            }
        }
        this.setState({ offersValue: apiData.result.offers });
        // if (this.state.offersValue.length == 1) {
        //     let offer = this.state.offersValue[0];
        //     if (offer.subProduct == "dd") {
        //         window.location.href = `/dd-al/vehicle-details?mobile=${this.lead.mobile}&promoCode=AL-DD-PROD1&customerId=${offer.customerId}&losAppId=${offer.losAppId}&campaignId=${offer.campaignId}`;
        //     }
        // }
        this.setState({ documentSubmit: true });
        this.setState({ otpPopUpSwitch: false });
    };
    // countDown(clear = false) {
    //     if (clear) clearInterval(x);
    //     let countDownDate = new Date(
    //         new Date().getTime() + 5 * 60 * 1000
    //     ).getTime();
    //     let x = setInterval(
    //         function () {
    //             let distance = countDownDate - new Date().getTime();
    //             this.setState({
    //                 otpTimer:
    //                     Math.floor(
    //                         (distance % (1000 * 60 * 60)) / (1000 * 60)
    //                     ) +
    //                     ":" +
    //                     Math.floor((distance % (1000 * 60)) / 1000),
    //             });
    //             if (distance < 0) {
    //                 clearInterval(x);
    //                 this.props.history.push("error");
    //                 return;
    //             }
    //         }.bind(this),
    //         1000
    //     );
    // }
    handleOnResend = async () => {
        this.lead = (this.context as AppContext).lead as leadType;
        await this.cAPI.resendOTP(this.lead);
    };
    handleOnSubmitOffer = (event) => {
        event.preventDefault();
        if (!this.state.offerSelectLosAppId) {
            // TODO: error handling to be done on setState failure;
        }
        this.state.offersValue.forEach((offer) => {
            this.lead = (this.context as AppContext).lead as leadType;
            if (offer.losAppId == this.state.offerSelectLosAppId) {
                event.currentTarget.submit();
            }
        });
    };
    render() {
        return (
            <>
                <div className="wrapper">
                    <HdfcHeader />
                    <section className="landing-wrap mt-72 h-full ">
                        <div className="container mx-auto px-5 flex flex-wrap flex-col">
                            <CongratsCarImg />
                            {!this.state.documentSubmit ? (
                                <>
                                    <form
                                        onSubmit={(e) =>
                                            this.handleOnSubmitMobileVerify(e)
                                        }
                                    >
                                        <div className="mb-6 mobile-num-wrap mx-auto md:w-6/12 w-full">
                                            <div className="relative w-full mb-3 md:mb-6">
                                                <InputForm
                                                    label="Mobile Number"
                                                    errorText="Please Enter Correct Mobile Number"
                                                    handlerOnChange={(e) => {
                                                        this.setLead({
                                                            mobile:
                                                                e.target.value,
                                                        });
                                                    }}
                                                    error={
                                                        this.state
                                                            .mobileInputError
                                                    }
                                                />
                                            </div>
                                            <div className="relative w-full mb-3 md:mb-6 text-left">
                                                <label className="custom-inputs inline-flex items-start">
                                                    <input
                                                        type="checkbox"
                                                        onChange={() => {
                                                            this.setState({
                                                                privacyPolicyCheck: !this
                                                                    .state
                                                                    .privacyPolicyCheck,
                                                            });
                                                        }}
                                                        checked={
                                                            this.state
                                                                .privacyPolicyCheck
                                                        }
                                                    />
                                                    <span></span>
                                                    <span className="ml-2 text-sm md:text-base lg:text-xl text-black openSans-Reg">
                                                        I am a major, a resident
                                                        of India, presently in
                                                        India and I have read
                                                        and I accept HDFC Bank
                                                        Ltd's.{" "}
                                                        <a
                                                            target="_blank"
                                                            href="https://www.hdfcbank.com/personal/useful-links/privacy"
                                                            className="blue-link-color no-underline hover:underline hover:text-black transition-all openSans-SemiBold"
                                                            title="Privacy Policy"
                                                        >
                                                            Privacy Policy
                                                        </a>
                                                    </span>
                                                </label>
                                                <br />
                                                <span
                                                    className={`error-msg-relative inline-block text-red-600 openSans-Reg text-xs md:text-sm lg:text-sm xl:text-sm ${this.state.privecyPolicyCheckClass}`}
                                                >
                                                    Please select Privacy Policy
                                                </span>
                                            </div>
                                            {/* <div className="relative w-full md:w-4/12 mx-auto my-4 md:my-8 text-center">
                                                <button
                                                    className="button-blue-bg hover:bg-blue-700 text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue"
                                                    title="Send OTP"
                                                >
                                                    Send OTP
                                                </button>
                                            </div>
                                            <div className="mx-auto relative text-center md:w-4/12 w-full">
                                                <button
                                                    type="reset"
                                                    className="bg-transparent border-2 button-blue-border blue-link-color hover:text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue button-white-blue mb-2 transition-all"
                                                    title="Reset"
                                                    onClick={() =>
                                                        this.handleOnReset()
                                                    }
                                                >
                                                    Reset
                                                </button>
                                            </div> */}
                                            <div className="w-full sm:w-10/12 mx-auto mt-8 flex flex-wrap justify-around">
                                                <div className="relative w-full sm:w-4/12 mx-auto mb-3 text-center">
                                                    <button
                                                        className="button-blue-bg hover:bg-blue-700 text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue mb-2 border-2 button-blue-border"
                                                        title="Send OTP"
                                                    >
                                                        Send OTP
                                                    </button>
                                                </div>
                                                <div className="relative w-full sm:w-4/12 mx-auto mb-3 text-center">
                                                    <button
                                                        type="reset"
                                                        className="bg-transparent border-2 button-blue-border blue-link-color hover:text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue button-white-blue mb-2 transition-all"
                                                        title="Reset"
                                                        onClick={() =>
                                                            this.handleOnReset()
                                                        }
                                                    >
                                                        Reset
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </>
                            ) : (
                                <>
                                    <form
                                        ref={this.formRef}
                                        action="/common-api/start-dd-journey"
                                        method="POST"
                                        onSubmit={(e) =>
                                            this.handleOnSubmitOffer(e)
                                        }
                                    >
                                        <div className="mb-6 multi-loan-wrap mx-auto md:w-8/12 w-full">
                                            <div className="text-center my-4 w-full">
                                                <p className="openSans-Reg text-center text-sm md:text-base lg:text-lg my-4">
                                                    You have already submitted
                                                    online/physical request(s)
                                                    for the following which are
                                                    shown in our system:
                                                </p>
                                            </div>
                                            <table className="w-full flex flex-col flex-wrap bg-white my-5 text-sm md:text-base openSans-Reg">
                                                <thead className="w-full flex flex-col flex-wrap">
                                                    <tr className="w-full flex flex-row flex-wrap lighter-blue-2 text-black text-center">
                                                        <th className="px-1 md:px-2 py-3 md:py-2 w-3/12 border-table">
                                                            Select Loan
                                                        </th>
                                                        <th className="px-1 md:px-2 py-3 md:py-2 w-5/12 border-table">
                                                            Loan Number
                                                        </th>
                                                        <th className="px-1 md:px-2 py-3 md:py-2 w-4/12 border-table">
                                                            Amount
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="w-full">
                                                    {this.state.offersValue.map(
                                                        (offer, index) => {
                                                            return (
                                                                <>
                                                                    <tr className="w-full flex flex-row flex-wrap hover:bg-gray-100 text-black text-center">
                                                                        <td className="w-3/12 border-table px-1 md:px-2 py-3 md:py-2">
                                                                            <div className="custom-inputs">
                                                                                <label className="inline-flex items-center">
                                                                                    <input
                                                                                        type="radio"
                                                                                        name="losAppId"
                                                                                        value={
                                                                                            offer.losAppId
                                                                                        }
                                                                                        onClick={(
                                                                                            e
                                                                                        ) =>
                                                                                            this.setState(
                                                                                                {
                                                                                                    offerSelectLosAppId:
                                                                                                        offer.losAppId,
                                                                                                    offerSelectedProduct:
                                                                                                        offer.product,
                                                                                                    offerSelectedSubProduct:
                                                                                                        offer.subProduct,
                                                                                                }
                                                                                            )
                                                                                        }
                                                                                    />
                                                                                    <span></span>
                                                                                </label>
                                                                            </div>
                                                                        </td>
                                                                        <td className="w-5/12 border-table px-1 md:px-2 py-3 md:py-2">
                                                                            {offer.product.toUpperCase()}{" "}
                                                                            -{" "}
                                                                            {
                                                                                offer.losAppId
                                                                            }
                                                                        </td>
                                                                        <td className="w-4/12 border-table px-1 md:px-2 py-3 md:py-2">
                                                                            {
                                                                                offer.loanAmt
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                </>
                                                            );
                                                        }
                                                    )}
                                                </tbody>
                                            </table>
                                            <input
                                                type="text"
                                                name="product"
                                                value={
                                                    this.state
                                                        .offerSelectedProduct
                                                }
                                                hidden
                                            />
                                            <input
                                                type="text"
                                                name="subProduct"
                                                value={
                                                    this.state
                                                        .offerSelectedSubProduct
                                                }
                                                hidden
                                            />
                                            <input
                                                type="text"
                                                name="authorization"
                                                value={
                                                    this.authKeeper
                                                        .authorization
                                                }
                                                hidden
                                            />
                                            {/* <div className="relative w-full md:w-4/12 mx-auto my-4 md:my-8 text-center">
                                                <button
                                                    className="button-blue-bg hover:bg-blue-700 text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue"
                                                    title="Confirm"
                                                >
                                                    Confirm
                                                </button>
                                            </div>
                                            <div className="mx-auto relative text-center md:w-4/12 w-full">
                                                <button
                                                    type="reset"
                                                    className="bg-transparent border-2 button-blue-border blue-link-color hover:text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue button-white-blue mb-2 transition-all"
                                                    title="Reset"
                                                >
                                                    Reset
                                                </button>
                                            </div> */}
                                            <div className="w-full sm:w-10/12 mx-auto mt-8 flex flex-wrap justify-around">
                                                <div className="relative w-full sm:w-4/12 mx-auto mb-3 text-center">
                                                    <button
                                                        className="button-blue-bg hover:bg-blue-700 text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue mb-2 border-2 button-blue-border"
                                                        title="Confirm"
                                                    >
                                                        Confirm
                                                    </button>
                                                </div>
                                                <div className="relative w-full sm:w-4/12 mx-auto mb-3 text-center">
                                                    <button
                                                        type="reset"
                                                        className="bg-transparent border-2 button-blue-border blue-link-color hover:text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue button-white-blue mb-2 transition-all"
                                                        title="Reset"
                                                    >
                                                        Reset
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </>
                            )}
                        </div>
                    </section>
                    {this.state.otpPopUpSwitch ? (
                        <OtpPopUp
                            onClose={() =>
                                this.setState({ otpPopUpSwitch: false })
                            }
                            handleOnOTPSubmit={() => this.handleOnOTPSubmit()}
                            timer={this.state.otpTimer}
                            buttonText="submit"
                            resendOTP={() => this.handleOnResend()}
                        />
                    ) : (
                        ""
                    )}
                </div>
            </>
        );
    }
}

export default CustomerVerification;
